import Component from '../core/Component'
import EventBus from '../core/EventBus'
import Scroll from '../services/Scroll'

export default class Footer extends Component {
    constructor(element) {
        super(element)

        this.state = {
            active: false,
        }
    }

    prepare() {
        Scroll.on('resize', this.handleResize)
        Scroll.on('scroll', this.handleScroll)
        this.resize()
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
        Scroll.off('scroll', this.handleScroll)
    }

    handleResize = () => {
        this.resize()
    }

    handleScroll = ({ offset }) => {
        this.render(offset.y)
    }

    resize() {
        this.windowHeight = window.innerHeight

        const toggleBox = document.getElementById('header-toggle').getBoundingClientRect()
        const box = this.element.getBoundingClientRect()
        const offset = Scroll.getScroll()
        const top = box.top + offset.y

        this.box = {
            top: top,
            height: box.height,
            headerTop: top - toggleBox.top - toggleBox.height / 2,
            headerBottom: top + box.height - toggleBox.top - toggleBox.height / 2,
        }
    }

    render(y) {
        if (y > this.box.headerTop && y < this.box.headerBottom) {
            if (!this.state.active) {
                this.state.active = true
                EventBus.emit('footer:enter')
            }
        } else {
            if (this.state.active) {
                this.state.active = false
                EventBus.emit('footer:leave')
            }
        }
    }
}
